import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./sentry.js";
import App from "./App"; // Assuming App handles routing

if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const resizeObserverLoopErr = /ResizeObserver loop/;
window.addEventListener(
  "error",
  (event) => {
    if (resizeObserverLoopErr.test(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App /> {/* Assuming App handles routing */}
  </StrictMode>
);
